module.exports = __webpack_public_path__ + "img/p4.51109f9b.gif";